package org.abhranilnxt.portfolio.models

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Theme(val hex: String, val rgb: CSSColorValue) {
    Primary("#00A78E", rgb = rgb(0, 167, 142)),
    Secondary("#121D34", rgb = rgb(18, 29, 52)),
    Gray("#CFCFCF", rgb = rgb(207, 207, 207)),
    LightGray("#F9F9F9", rgb = rgb(237, 237, 237)),
    LighterGray("#F9F9F9", rgb = rgb(249, 249, 249))
}